/**
 * What the chat does with a message row the duplexer pushed (outside this browser's own SSE turn).
 *
 * - `bubble`: an assistant reply or step, or the one USER row this browser did not send (a question the
 *   meeting room put to the agent).
 * - `status`: a THINKING row. It draws no bubble; it is the live status of a turn this browser is not
 *   streaming — a connect or any other server-started turn — and feeds the thinking line, replacing the
 *   connect placeholder the way it does on iOS and Android.
 * - `ignore`: everything else, including the USER rows this browser sent itself.
 */
export type LiveChatRowKind = 'bubble' | 'status' | 'ignore';

export function liveChatRowKind(role: string, fromMeetingRoom: boolean): LiveChatRowKind {
  if (role === 'ASSISTANT' || role === 'ASSISTANT_STEP' || fromMeetingRoom) return 'bubble';
  if (role === 'THINKING') return 'status';
  return 'ignore';
}
